import { dataTrackingLog } from "../core/utils";
import type { EventContext } from "../types";

export function pushToDito(event: string, ecomm: EventContext) {
  dataTrackingLog({ id: event, custom_data: ecomm }, '#00c851');
}